import { FuseNavigationItem } from "@fuse/components/navigation";

export const systemNavigation: FuseNavigationItem[] = [
    {
      id: 'systemdashboards',
      title: 'Dashboards',
      type: 'group',
      icon: 'heroicons_outline:rectangle-group',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
      id: 'assistance',
      title: 'Assistance',
      type: 'group',
      icon: 'heroicons_outline:user-group',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
      id: 'products',
      title: 'Products',
      type: 'group',
      icon: 'heroicons_outline:briefcase',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'group',
      icon: 'heroicons_outline:cog-6-tooth',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
      id: 'space-route',
      title: 'Space Route',
      type: 'spacer',
      children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
  ];